if (!customElements.get('collection-siblings')) {
  class CollectionSiblings extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('pageshow', this.onPageShow);
    }

    onClick(event) {
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const item = event.target.closest('a.collection-siblings__item');
      if (!item || !this.contains(item) || item.classList.contains('is-loading')) {
        return;
      }

      this.setLoading(item);
    }

    onPageShow() {
      this.resetLoading();
    }

    setLoading(item) {
      this.classList.add('is-loading');
      item.classList.add('is-loading');
      item.setAttribute('aria-busy', 'true');

      const status = this.querySelector('[data-collection-siblings-status]');
      if (status) {
        status.textContent = this.dataset.loadingLabel || '';
      }
    }

    resetLoading() {
      this.classList.remove('is-loading');
      this.querySelectorAll('.collection-siblings__item.is-loading').forEach(
        (item) => {
          item.classList.remove('is-loading');
          item.removeAttribute('aria-busy');
        }
      );

      const status = this.querySelector('[data-collection-siblings-status]');
      if (status) status.textContent = '';
    }
  }

  customElements.define('collection-siblings', CollectionSiblings);
}
